import Heart from './Heart';
import woman from "../pages/Images/woman.png";

// price	
// qty	
// totalAmount	
// productId	
// customerId

export default function CartItemCard() {
  return (
    <div className="bg-white flex justify-between md:p-4 divide-x w-full my-6">
      <div className="w-7/12 md:w-48p p-3 flex justify-between">
        <div className="md:w-4/12 hidden md:flex justify-center">
          <img src={woman} alt="" />
        </div>
        <div className="md:w-7/12 relative">
          <p className="text-gray1 text-sm">Seller OG Money</p>
          <p className="font-medium text-lg md:text-xl my-8">
            ABC Ankara - Deluxe Edition
          </p>
          <div className="flex justify-between md:absolute bottom-0 w-full text-xs md:text-sm">
            <button className="text-primary font-semibold">
             <Heart /> Move to saved Items
            </button>
            <button className="text-primary font-semibold">Remove</button>
          </div>
        </div>
      </div>
      <div className="w-2/12 p-3 flex justify-center items-center">
        <input type="number" value="1" className="focus:outline-none w-10  text-center" />
      </div>
      <div className="w-3/12 md:w-2/12 p-3 flex justify-center items-center">
        <div className="text-center font-bold">
          <p className="text-lg md:text-xl my-2">50,000</p>
          <p className="md:text-lg line-through text-gray1 my-2">70,000</p>
          <p className="text-sm text-green my-2">savings 20,000</p>
        </div>
      </div>
      <div className="w-2/12 p-3 hidden md:flex justify-center items-center">
        <p className="font-bold text-primary">50,000</p>
      </div>
    </div>
  );
}
